if (!customElements.get('scrolling-text')) {
  customElements.define(
    'scrolling-text',
    class ScrollingText extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setDefaultStyle();
        this.list = this.querySelector('ul');
        if(this.list) {
          this.items = this.list.innerHTML;
          this.fillBanner();
          this.startAnimation();
          window.addEventListener('resize', () => {
            this.reload();
          });
        }
      }

      setDefaultStyle() {
        this.style.display = 'flex';
        this.style.flexWrap = 'nowrap';
        this.style.position = 'relative'
      }

      startAnimation() {
        const observer = new IntersectionObserver(function(entries) {
          if(entries[0].isIntersecting === true) {
            entries[0]['target'].setAnimationClasses();
          }
          else {
            entries[0]['target'].stopAnimation();
          }
        }, { threshold: [0]});
        observer.observe(this);
      }

      stopAnimation() {
        this.removeAnimationClasses();
      }

      setAnimationClasses() {
        this.list.classList.add('xl:animate-[scroll-text_var(--animation-duration-desktop)_infinite_linear]');
        this.list.classList.add('md:animate-[scroll-text_var(--animation-duration-tablet)_infinite_linear]');
        this.list.classList.add('animate-[scroll-text_var(--animation-duration-mobile)_infinite_linear]');
      }

      removeAnimationClasses() {
        this.list.classList.remove('xl:animate-[scroll-text_var(--animation-duration-desktop)_infinite_linear]');
        this.list.classList.remove('md:animate-[scroll-text_var(--animation-duration-tablet)_infinite_linear]');
        this.list.classList.remove('animate-[scroll-text_var(--animation-duration-mobile)_infinite_linear]');
      }

      reload() {
        this.stopAnimation();
        this.list.innerHTML = this.items;
        this.fillBanner();
        this.startAnimation();
      }

      fillBanner() {
        const style = getComputedStyle(this);
        const screenWidth = parseFloat(style.width);
        while (this.calcListWidth() < (screenWidth * 2)) {
          this.list.innerHTML += this.items;
        }
        this.list.style.width = `${this.calcListWidth()}px`;
      }

      calcListWidth() {
        const clone = this.list.cloneNode(true);
        Object.assign(clone.style, {
          overflow: 'visible',
          height: 'auto',
          opacity: '0',
          visibility: 'hidden',
          width: 'max-content'
        });
        this.after(clone);
        const width = clone.offsetWidth;
        clone.remove();
        return width;
      }

      isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }
    }
  )
}